import React from 'react'
import {
  useAuth,
  GroupMemberRole,
  CompanyMemberRole,
  useCompanyMember,
  UserRole,
  CompanyIsAllowed,
} from '@modmd/data'
import { ROUTES, PERSONAL_ROUTES, COMPANY_ROUTES } from 'client-portal/constants/routes'
import { PageLayout, PageNavLink } from './PageLayout'

interface Props {
  title?: string
  hasCenteredContent?: boolean
  hasContentPadding?: boolean
  onBackClick?: () => void
}

export const PersonalPageLayout: React.FC<Props> = ({
  children,
  title,
  hasCenteredContent,
  hasContentPadding,
  onBackClick,
}) => {
  const auth = useAuth()
  const { hasRoles } = useAuth()
  const isSuperAdmin = hasRoles([UserRole.SUPER_ADMIN])
  const isCLS = hasRoles([UserRole.CLS])
  const { getUserGroupsWithRole, getUserCompaniesWithRole } = useAuth()
  const { companies } = getUserCompaniesWithRole({
    roles: [CompanyMemberRole.Owner, CompanyMemberRole.Manager],
  })
  const { groups } = getUserGroupsWithRole({
    roles: [GroupMemberRole.Manager, GroupMemberRole.Coordinator],
  })

  const companyId = companies[0]?.id ?? groups[0]?.companyId

  const { data: isCompanyAllowed } = useCompanyMember({
    userId: auth.data.User.id,
  }) as CompanyIsAllowed

  const navLinks = React.useMemo(() => {
    const links = [
      { to: `/${ROUTES.REQUEST_TEST_SESSION}`, label: 'Schedule Test' },
      { to: `/${ROUTES.PERSONAL}/${PERSONAL_ROUTES.TESTS}`, label: 'Results' },
      { to: `/${ROUTES.PERSONAL}/${PERSONAL_ROUTES.SESSIONS}`, label: 'Test sessions' },
      {
        to: `/${ROUTES.PERSONAL}/${PERSONAL_ROUTES.SETTINGS}`,
        label: 'Profile',
        sublinks: [
          {
            to: `/${ROUTES.PERSONAL}/${
              isSuperAdmin || isCompanyAllowed?.companyMember || isCLS
                ? PERSONAL_ROUTES.VACCINES
                : PERSONAL_ROUTES.SETTINGS_VACCINE_RECORD
            }`,
            label: 'Vaccine Record',
          },
          { to: `/${ROUTES.PERSONAL}/${PERSONAL_ROUTES.SETTINGS_INSURANCE}`, label: 'Insurance' },
        ],
      },
    ].filter(Boolean) as PageNavLink[]
    return companyId
      ? [
          ...links,
          {
            to: `/${ROUTES.COMPANY}/${companyId}/${COMPANY_ROUTES.TEST_SESSIONS}`,
            label: 'Company',
          },
        ]
      : links
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, isCompanyAllowed, isSuperAdmin, isCLS])
  return (
    <PageLayout
      navLinks={navLinks}
      title={title}
      hasCenteredContent={hasCenteredContent}
      hasContentPadding={hasContentPadding}
      onBackClick={onBackClick}
    >
      {children}
    </PageLayout>
  )
}
